import React from "react";
import ProductItem from "../../components/product/ProductItem";
// BtnAddToCart
import MiniBtnAddToCart from "../../components/layout/Buttons/MiniBtn-Add-To-Cart";

const ProductsTable = ({ products}) => {



  return (
    <div className="overflow-x-auto w-full">
      <table className="border-t-0 border-black border-solid md:border-t-4 border-[#011936] w-full min-w-[800px] md:min-w-full">
        <thead className="md:table-header-group">
          <tr className="bg-white md:bg-[#E7E9EB] *:p-1 md:*:p-3 *:bg-inherit *:text-[#2684fe] md:*:text-[#2684fe] *:font-bold *:text-[10px] md:*:text-sm uppercase tracking-wider">
            <th className="sticky md:static left-0 z-20 bg-white md:bg-inherit w-[100px] md:w-[350px] border-r-2 border-solid border-r-gray-400/20 text-center shadow-[2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
              Product Details
            </th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Manufacturer</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Stock</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Price ($)</th>
            <th className="border-r-2 border-solid border-r-gray-400/20 text-center">Creatyea Part No.</th>
            <th className="sticky md:static right-0 z-20 bg-white md:bg-inherit text-center shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
              Order
            </th>
          </tr>
        </thead>
        <tbody>
          {products?.map((product, i) => (
            <tr
              key={product?._id}
              className="bg-white *:py-4 *:px-3 *:border-b border-gray-200 transition-colors duration-200 hover:bg-gray-50"
            >
              <ProductItem product={product} />
              <td className="sticky md:static right-0 z-10 bg-white md:bg-inherit border-l-0 border-solid md:border-l-2 border-l-gray-400/20 shadow-[-2px_0_5px_-2px_rgba(0,0,0,0.1)] md:shadow-none">
                <div className="flex items-center justify-center w-full bg-inherit">
                  <MiniBtnAddToCart {...product} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductsTable;
